import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { FiRefreshCw } from "react-icons/fi";
import "./Register.css";
import { Button } from "primereact/button";
import Swal from "sweetalert2";
import RegImg from "../Images/Reg.png";

const Register = forwardRef((props, ref) => {
  const [fullName, setFullName] = useState("");
  const [workEmailID, setWorkEmailID] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [mobilePrefix, setMobilePrefix] = useState(91);
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [designation, setDesignation] = useState("");
  const [employeesCount, setEmployeesCount] = useState("");
  const [registerMessage, setRegisterMessage] = useState("");
  const [invalid, setInvalid] = useState(false);
  const [answer, setAnswer] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [text, setText] = useState("");
  const [visible, setVisible] = useState(props.visible);
  useImperativeHandle(ref, () => ({
    callRegisterComponent() {
      setVisible(true);
      generateCaptcha();
    },
  }));
  const generateCaptcha = () => {
    const number1 = Math.floor(Math.random() * 10) + 1;
    const number2 = Math.floor(Math.random() * 10) + 1;
    const operation = Math.random() < 0.5 ? "+" : "-";
    const result = operation === "+" ? number1 + number2 : number1 - number2;

    setCaptchaText(`${number1} ${operation} ${number2} = `);
    setAnswer(result.toString());
  };
  const roles = [
    { name: "CEO", value: "CEO" },
    { name: "Director", value: "Director" },
    { name: "Chairman", value: "Chairman" },
    { name: "Manager", value: "Manager" },
    { name: "Account Executive", value: "Account Executive" },
    { name: "HR Manager", value: "HR Manager" },
    { name: "HR Executive", value: "HR Executive" },
    { name: "IT Executive", value: "IT Executive" },
    { name: "Finance Manager", value: "Finance Manager" },
    { name: "Student", value: "Student" },
    { name: "Admin", value: "Admin" },
    { name: "Other", value: "Other" },
  ];
  const employeeCounts = [
    { name: "1-50", value: "1-50" },
    { name: "51-100", value: "51-100" },
    { name: "101-500", value: "101-500" },
    { name: "501-1000", value: "501-1000" },
    { name: "1000+", value: "1000+" },
  ];
  const handleRegisterSubmit = async (event) => {
    event.preventDefault();
    if (answer === text) {
      setInvalid(false);
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Captcha",
        text: "Please enter a valid Captcha",
        timer: 2000,
        showConfirmButton: false,
      });
      setInvalid(true);
      generateCaptcha();
      return;
    }

    try {
      const response = await fetch("/saveRegestrations", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: fullName,
          mobileNumber: parseInt(mobilePrefix + "" + mobileNumber),
          workEmailID: workEmailID,
          companyName: companyName,
          companyAddress: companyAddress,
          designation: designation,
          employeesCount: employeesCount,
          registerMessage: registerMessage,
        }),
      });

      if (response.ok) {
        setVisible(false);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Registration data saved successfully.",
          timer: 2500,
          showConfirmButton: false,
        });

        // Optionally reset form fields after successful submission
        setFullName("");
        setMobilePrefix("+91");
        setMobileNumber("");
        setText("");
        setWorkEmailID("");
        setCompanyName("");
        setCompanyAddress("");
        setDesignation("");
        setEmployeesCount("");
        setRegisterMessage("");
        generateCaptcha();
      } else {
        console.error("Failed to save registration data");
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to save registration data. Please try again later.",
          timer: 2000,
          showConfirmButton: false,
        });
        // Handle error scenario if needed
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while saving registration data. Please try again later.",
        timer: 2000,
        showConfirmButton: false,
      });
      console.error("Error occurred while saving registration data:", error);

      // Handle network or other errors
    }
  };

  return (
    <Dialog
      visible={visible}
      modal
      className="R-dialog"
      header={"Register Here"}
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}>
      <div className="Register-form">
        <div className="reg-img-section">
          <img src={RegImg} alt="registerimg" />
        </div>
        <Card className="contact-form">
          <form onSubmit={handleRegisterSubmit} method="post">
            <table className="contact-form-table" cellPadding={"8px"}>
              <tr>
                <td colSpan={2} className="floating-label-container">
                  <InputText
                    keyfilter={/^[a-zA-Z ]*$/}
                    onChange={(e) => setFullName(e.target.value)}
                    value={fullName}
                    pattern=".{3,50}"
                    placeholder=" "
                  />
                  <div className="label-line">Enter Your Name</div>
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="floating-label-container mobile-label">
                  <Dropdown
                    style={{ zIndex: "2" }}
                    options={[{ name: "+91", value: 91 }]}
                    value={mobilePrefix}
                    onChange={(e) => setMobilePrefix(e.value)}
                    optionLabel="name"
                    placeholder="+91"
                    className="drop-down-contact"
                  />
                  <InputText
                    pattern=".{10}"
                    className="contact-number"
                    keyfilter="pint"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    placeholder=" "
                  />
                  <div className="label-line">Contact Number</div>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="floating-label-container">
                  <InputText
                    type="email"
                    value={workEmailID}
                    onChange={(e) => setWorkEmailID(e.target.value)}
                    placeholder=" "
                  />
                  <div className="label-line">Work Email ID</div>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="floating-label-container">
                  <InputText
                    pattern=".{3,50}"
                    value={companyName}
                    keyfilter={/^[a-zA-Z ]*$/}
                    onChange={(e) => setCompanyName(e.target.value)}
                    placeholder=" "
                  />
                  <div className="label-line">Company Name</div>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="floating-label-container">
                  <InputText
                    keyfilter={/^[a-zA-Z @#\/]*$/}
                    pattern=".{3,200}"
                    value={companyAddress}
                    onChange={(e) => setCompanyAddress(e.target.value)}
                    placeholder=" "
                  />
                  <div className="label-line">Company Address</div>
                </td>
              </tr>
              <tr className="twoCols">
                <td>
                  <Dropdown
                    options={roles}
                    filter
                    optionLabel="name"
                    value={designation}
                    onChange={(e) => setDesignation(e.value)}
                    placeholder="Designation"
                    className="w-full"
                  />
                </td>
                <td>
                  <Dropdown
                    options={employeeCounts}
                    optionLabel="name"
                    value={employeesCount}
                    placeholder="Employee Count"
                    className="w-full"
                    onChange={(e) => setEmployeesCount(e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="floating-label-container">
                  <InputTextarea
                    style={{ width: "100%" }}
                    rows={5}
                    cols={30}
                    value={registerMessage}
                    onChange={(e) => setRegisterMessage(e.target.value)}
                    placeholder=" "
                  />
                  <div className="label-line">Register Message</div>
                </td>
              </tr>
              <tr>
                <td style={{ padding: "0px" }} colSpan={2}>
                  <div className="captcha">
                    {captchaText}
                    <FiRefreshCw
                      onClick={generateCaptcha}
                      className="captcha-icon"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="floating-label-container">
                  <InputText
                    keyfilter={"int"}
                    value={text}
                    placeholder=" "
                    onChange={(e) => setText(e.target.value)}
                  />
                  <div className="label-line">Enter Captcha</div>
                  {invalid && (
                    <p
                      style={{
                        color: "red",
                        margin: "0",
                        marginTop: "10px",
                      }}>
                      Invalid Captcha
                    </p>
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <Button
                    label="Submit"
                    // onClick={() => generateCaptcha()}
                    style={{ width: "100%" }}
                    disabled={
                      !fullName ||
                      !mobileNumber ||
                      !workEmailID ||
                      !companyName ||
                      !companyAddress ||
                      !designation ||
                      !employeesCount ||
                      !registerMessage ||
                      !text
                    }
                  />
                </td>
              </tr>
            </table>
          </form>
        </Card>
      </div>
    </Dialog>
  );
});

export default Register;
